package com.appcreator.dto

import com.appcreator.blueprint.components.Screen
import kotlin.time.Instant
import kotlinx.serialization.Serializable

@Serializable
data class ScreenResponse(
    val screen: Screen,
    val updatedAt: Instant
)
